export default __webpack_public_path__ + "static/media/Brief Project.89fe47f8.svg";